import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstanceJson from "../../../AxiosInstance/axiosInstanceJson";

export const createResultCategory = createAsyncThunk(
  "ResultCategory/createResultCategory",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.post(
        `/v1/admin/resultCategory/create-resultCategory`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getResultCategory = createAsyncThunk(
  "ResultCategory/getResultCategory",
  async (
    {
      id,
      status = "All",
      search = "",
      page = 1,
      limit = 10,
      startDate,
      endDate,
      paginate,
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/resultCategory/get-resultCategory`,
        {
          params: {
            id,
            status,
            search,
            page,
            limit,
            startDate,
            endDate,
            paginate,
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error occurred");
    }
  }
);

export const deleteResultCategory = createAsyncThunk(
  "ResultCategory/deleteResultCategory",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/resultCategory/delete-resultCategory/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const undoDeleteResultCategory = createAsyncThunk(
  "ResultCategory/undoDeleteResultCategory",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/resultCategory/undodelete-resultCategory/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getSingleResultCategory = createAsyncThunk(
  "ResultCategory/getSingleResultCategory",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/resultCategory/getSingle-resultCategory/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const updateResultCategory = createAsyncThunk(
  "ResultCategory/updateResultCategory",
  async ({ _id, formData }, thunkAPI) => {
    try {
      const response = await axiosInstanceJson.put(
        `/v1/admin/resultCategory/update-resultCategory/${_id}`,
        formData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getAllResultCategory = createAsyncThunk(
  "ResultCategory/getAllResultCategory",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/resultCategory/get-allresultCategory`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
